import {formatDateToLocal} from "../../../../../Helpers/Helpers";

export const TableHelpers = {
    data() {
        return {
            tableColumns : [
                {
                    title: 'Type',
                    type: 'custom-html',
                    key: 'type_name',
                    modifier: (value) => {
                        return value ? value : '-';
                    }
                },
                {
                    title: 'PDF',
                    type: 'custom-html',
                    key: 'source_pdf',
                    modifier: (value) => {
                        return `<a href="${value}" target="_blank" class="btn btn-sm btn-primary">View PDF</a>`;
                    }
                },
                {
                    title: this.$t('status'),
                    type: 'custom-html',
                    key: 'status',
                    modifier: (value) => {
                        let ClassName = 'danger';

                        if (value === 'active') ClassName = `success`;
                        else if (value === 'inactive') ClassName = `warning`;

                        return `<span class="badge badge-${ClassName}">${value}</span>`;
                    }
                },
            ],
            actionObj : {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}